/* eslint-disable */
export default {
  _click: 'click',
  _correct_classic: 'correct_classic',
  _correct_lava: 'correct_lava',
  _correct_rainbow: 'correct_rainbow',
  _correct_scifi: 'correct_scifi',
  _correct_slime: 'correct_slime',
  _correct_wood: 'correct_wood',
  _flash_camera: 'flash_camera',
  _good_job: 'good_job',
  _incorrect_answer: 'incorrect_answer',
  _jingle: 'jingle',
  _keyboard_swirl_long: 'keyboard_swirl_long',
  _keyboard_swirl_short: 'keyboard_swirl_short',
  _tween: 'tween',
}